module.exports = {
    API_KEY : "d42a0d190464a2be90977c3996382811",
    API_BASE_URL : 'https://api.spotlight.chiratae.com/front/v1',
    FRONT_BASE_URL: 'https://spotlight.chiratae.com',
    NOIMAGE : 'https://chiratae.algoapi.in/apiv2/uploads/images/2044895393280820241203407743538826.png',
    // API_BASE_URL : 'https://algodev.in:63005/front/v1',
    // FRONT_BASE_URL : "https://algodev.in:63005",
    // API_BASE_URL : 'http://localhost:63005/front/v1',
    // FRONT_BASE_URL : "http://localhost:3000",
}